/**
 * Что для цели «чужое» (фидбек владельца 27.07: маршрут шёл сквозь корпуса
 * соседей): двери и контуры посторонних зданий. Сам штраф за пересечение — в
 * route.ts, здесь только состав «чужого».
 */
import { DOOR_KINDS, hostUnitOf, pointInRing, sameBuildingUnits } from './route-geom'
import type { Venue } from './types'

/**
 * Двери и контуры ЧУЖИХ зданий — чтобы маршрут не шёл сквозь соседей.
 */
export function foreignDoorIds(venue: Venue, targetId: string): Set<string> {
  const target = venue.units.find((u) => u.id === targetId) ?? hostUnitOf(venue, targetId)
  const own = target ? ownAccessIds(venue, target) : new Set<string>()
  const foreign = new Set<string>()
  for (const n of venue.network.nodes) {
    if (DOOR_KINDS.has(n.kind) && !own.has(n.id)) foreign.add(n.id)
  }
  return foreign
}

/** Узлы, «принадлежащие» корпусу цели: привязки + всё внутри его контуров. */
function ownAccessIds(venue: Venue, target: Venue['units'][number]): Set<string> {
  const own = new Set<string>()
  for (const u of sameBuildingUnits(venue, target)) {
    for (const e of u.entrances ?? []) own.add(e)
    for (const d of u.docks ?? []) own.add(d)
    const ring = u.geometry.coordinates[0]
    for (const n of venue.network.nodes) {
      if (n.unit === u.id || (ring && pointInRing(n.point, ring))) own.add(n.id)
    }
  }
  return own
}

/**
 * Контуры ЧУЖИХ зданий (не корпус цели). Маршрут не должен ни заканчиваться,
 * ни «сходить с сети» внутри них: на карте это читается как «машина заезжает в
 * соседнее здание» (фидбек владельца 27.07 — SKL1k через «Склад B»).
 */
export function foreignFootprints(venue: Venue, targetId: string): number[][][] {
  const target = venue.units.find((u) => u.id === targetId) ?? hostUnitOf(venue, targetId)
  const own = new Set(target ? sameBuildingUnits(venue, target).map((u) => u.id) : [])
  const rings: number[][][] = []
  for (const u of venue.units) {
    if (own.has(u.id)) continue
    const ring = u.geometry.coordinates[0]
    if (ring && ring.length >= 3) rings.push(ring)
  }
  return rings
}
